function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { rgba } from "../../../utils/styleUtils";
function buildStyle(param, param1, param2) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, font = param.font, depth = param.depth, size = param.size, animation = param.animation, readingDirection = param1.readingDirection, start = param1.start, end = param1.end, typographyUpdates = param2.typographyUpdates;
    var focusStyles = {
        outline: 0,
        boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.interactive.focus)
    };
    var navigationLinkHover = {
        backgroundColor: rgba(backgroundColor.selectList.hover, depth.opacity.light)
    };
    var navigationLinkActive = {
        color: font.color.interactive.base,
        backgroundColor: backgroundColor.selectList.active
    };
    var sharedBaseStyles = _objectSpread({
        cursor: 'pointer',
        fontFamily: font.base.family
    }, readingDirection, {
        textDecoration: 'none',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: font.color.base,
        fontSize: font.base.size.m,
        fontWeight: typographyUpdates ? font.base.weight.regular : font.base.weight.light
    });
    var _obj;
    var sharedDivStyles = _objectSpread({}, readingDirection, (_obj = {
        borderRadius: size.border.radius.fiveX,
        width: '100%',
        height: 'calc(100% - 8px)'
    }, _defineProperty(_obj, start.padding, 16), _defineProperty(_obj, end.padding, 16), _defineProperty(_obj, "marginTop", 4), _defineProperty(_obj, "marginBottom", 4), _defineProperty(_obj, start.margin, 0), _defineProperty(_obj, end.margin, 6), _defineProperty(_obj, "whiteSpace", 'nowrap'), _defineProperty(_obj, "textDecoration", 'none'), _defineProperty(_obj, "fontFamily", font.base.family), _defineProperty(_obj, "color", font.color.base), _defineProperty(_obj, "fontSize", font.base.size.m), _defineProperty(_obj, "fontWeight", typographyUpdates ? font.base.weight.regular : font.base.weight.light), _defineProperty(_obj, "display", 'flex'), _defineProperty(_obj, "alignItems", 'center'), _defineProperty(_obj, "justifyContent", 'center'), _defineProperty(_obj, "transitionProperty", 'box-shadow'), _defineProperty(_obj, "transitionDuration", animation.duration[100]), _defineProperty(_obj, "transitionTimingFunction", animation.productive.easeInOut.easing), _defineProperty(_obj, "svg", _defineProperty({}, start.padding, 8)), _defineProperty(_obj, '&:focus-visible', _objectSpread({}, focusStyles)), _obj));
    var _obj1;
    var sharedAStyles = _objectSpread({}, readingDirection, (_obj1 = {
        borderRadius: size.border.radius.fiveX
    }, _defineProperty(_obj1, start.padding, 20), _defineProperty(_obj1, end.padding, 20), _defineProperty(_obj1, end.margin, 6), _defineProperty(_obj1, "width", '100%'), _defineProperty(_obj1, "height", 'calc(100% - 8px)'), _defineProperty(_obj1, "whiteSpace", 'nowrap'), _defineProperty(_obj1, "textDecoration", 'none'), _defineProperty(_obj1, "fontFamily", font.base.family), _defineProperty(_obj1, "color", font.color.base), _defineProperty(_obj1, "fontSize", font.base.size.m), _defineProperty(_obj1, "fontWeight", typographyUpdates ? font.base.weight.regular : font.base.weight.light), _defineProperty(_obj1, "display", 'flex'), _defineProperty(_obj1, "alignItems", 'center'), _defineProperty(_obj1, "justifyContent", 'center'), _defineProperty(_obj1, "transitionProperty", 'box-shadow'), _defineProperty(_obj1, "transitionDuration", animation.duration[100]), _defineProperty(_obj1, "transitionTimingFunction", animation.productive.easeInOut.easing), _defineProperty(_obj1, '&:focus-visible', _objectSpread({}, focusStyles)), _obj1));
    return {
        navigationLink: _objectSpread({}, sharedBaseStyles, {
            '&:hover': {
                div: _objectSpread({}, navigationLinkHover),
                a: _objectSpread({}, navigationLinkHover)
            },
            '&:active': {
                div: _objectSpread({}, navigationLinkActive),
                a: _objectSpread({}, navigationLinkActive)
            },
            div: _objectSpread({}, sharedDivStyles),
            a: _objectSpread({}, sharedAStyles)
        }),
        selectedLink: _objectSpread({}, sharedBaseStyles, {
            div: _objectSpread({}, sharedDivStyles, navigationLinkActive),
            a: _objectSpread({}, sharedAStyles, navigationLinkActive),
            '& span, & svg': {
                fill: "".concat(font.color.interactive.base, " !important")
            }
        })
    };
}
export default function useStyle(isRtl) {
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            navigationLinkStyles: {},
            selectedLinkStyles: {}
        };
    }
    var navigationLink = builtStyle.navigationLink, selectedLink = builtStyle.selectedLink;
    return {
        navigationLinkStyles: navigationLink,
        selectedLinkStyles: selectedLink
    };
};
